import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import PieChartOutlineOutlinedIcon from '@mui/icons-material/PieChartOutlineOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import { useTranslation } from 'react-i18next';
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { RoleContext } from 'src/context/roleContext';
import { Link } from 'react-router-dom';

const Item = ({
  title,
  to,
  icon,
  selected,
  setSelected,
  onClick,
  isCollapsed
}) => {
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: selected === title ? '#007bff' : '#333333',
        background: selected === title ? '#f0f4ff' : 'transparent',
        borderRadius: '8px',
        margin: '8px 0',
        transition: 'background 0.3s, color 0.3s',
        padding: isCollapsed ? '8px' : '0px',
        justifyContent: isCollapsed ? 'center' : 'flex-start'
      }}
      onClick={() => {
        setSelected(title);
        if (onClick) onClick();
      }}
      icon={icon}
    >
      {!isCollapsed && (
        <Typography sx={{ fontWeight: selected === title ? 'bold' : 'normal' }}>
          {title}
        </Typography>
      )}
      <Link to={to} />
    </MenuItem>
  );
};

const SchoolSidebarItems = ({
  selected,
  setSelected,
  onLogout,
  isCollapsed
}) => {
  const { t } = useTranslation();
  const { schoolId } = useContext(RoleContext);

  return (
    <ProSidebar
      collapsed={isCollapsed}
      style={{
        backgroundColor: '#e0e9f4 ',
        color: '#333333',
        borderRadius: '12px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden'
      }}
    >
      <Menu iconShape="circle">
        {!isCollapsed && (
          <Typography
            variant="h5"
            color="#555555"
            sx={{
              m: '10px 0 0 16px',
              textTransform: 'uppercase',
              fontSize: '14px'
            }}
          >
            {t('meni.students')}
          </Typography>
        )}
        <Item
          title={t('meni.allStudents')}
          to={`/all-students/${schoolId}`}
          icon={<SchoolOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />
        <Item
          title={t('meni.results')}
          to="/schoolResults"
          icon={<AssessmentOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />
        <Item
          title={t('meni.schoolWorkReview')} 
          to={`/school/${schoolId}`} 
          icon={<SchoolOutlinedIcon />} 
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />

        {!isCollapsed && (
          <Typography
            variant="h5"
            color="#555555"
            sx={{
              m: '10px 0 0 16px',
              textTransform: 'uppercase',
              fontSize: '14px'
            }}
          >
            {t('meni.complaintsForStudent')}
          </Typography>
        )}
        <Item
          title={t('meni.reviewComplaints')}
          to={`/complaints/${schoolId}`}
          icon={<FeedbackOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />
        <Item
          title={t('meni.newComplaints')}
          to="/createComplaint"
          icon={<FeedbackOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />

        {!isCollapsed && (
          <Typography
            variant="h5"
            color="#555555"
            sx={{
              m: '10px 0 0 16px',
              textTransform: 'uppercase',
              fontSize: '14px'
            }}
          >
            {t('meni.statistics')}
          </Typography>
        )}

        <Item
          title={t('meni.classandCategoryStatistics')}
          to="/statisticsByClass"
          icon={<BarChartOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />
        <Item
          title={t('meni.languageStatistics')}
          to="/statisticByLanguage"
          icon={<PieChartOutlineOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />
        <Item
          title={t('meni.genderStatistics')}
          to="/statisticByGender"
          icon={<InsertChartOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />
        {!isCollapsed && (
          <Typography
            variant="h5"
            color="#555555"
            sx={{
              m: '10px 0 0 16px',
              textTransform: 'uppercase',
              fontSize: '14px'
            }}
          >
            {t('meni.settings')}
          </Typography>
        )}
        <Item
          title={t('meni.profile')}
          to="/ProfilePage"
          icon={<AccountCircleOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
        />
        <Item
          title={t('meni.logout')}
          to="#"
          icon={<ExitToAppOutlinedIcon />}
          selected={selected}
          setSelected={setSelected}
          onClick={onLogout}
          isCollapsed={isCollapsed}
        />
      </Menu>
    </ProSidebar>
  );
};

export default SchoolSidebarItems;
